import AppErrorIndicator from './AppErrorIndicator';

export default AppErrorIndicator;
